<template>
    <div>
        <div class="container page-container">
            <transition name="slideLeft">
                <div class="container">
                    <component :is="currentComponent" class="page-component"></component>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import * as MutationTypes from '@/store/mutation-types';
    import ReplacementView from '@/views/dev/pages/replacements'
    import Config from '@/config';

    const pageComponents = {
        'replacements': ReplacementView,
    };

    export default {
        name: 'admin-controller',
        beforeMount() {
            this.$apiClient.setBaseUrl(Config.baseApiUrl);

            this.$store.commit(MutationTypes.SET_CURRENT_APP_SEGMENT, 'dev');
            this.$store.commit(MutationTypes.SET_CURRENT_BACKGROUND, null);
        },
        computed: {
            currentPage() {
                return this.$route.params.page || 'replacements';
            },
            currentComponent() {
                return pageComponents[this.currentPage];
            },
        }
    }
</script>

<style lang="scss">
    @import "../../../node_modules/vue-notifyjs/themes/default.css";
</style>

<style lang="scss" scoped>
    .page-container {
        position: relative;
        padding-top: 70px;
    }

    .page {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }
</style>